const alo7Theme = {
  primaryColor: 'rgba(28, 197, 165, 1)',
  primaryColorLight: 'rgba(30,40,75,0.1)',
  borderColor: '#d9d9d9',
  auxColor: '#ffb21e',
  borderRadius: '4px'
}

window.alo7Theme = alo7Theme;
